import runPage from './runtime/Page';
import runForm from './runtime/Form';
import runCommand from './runtime/Command';
import runEventHandler from './runtime/EventHandler';
import runEventHandlerDecorator from './runtime/EventHandlerDecorator';
import runInteractionListener from './runtime/InteractionListener';
import runInjector from './config/Injector';
import runComponent from './config/Component';
import runRuntimeBuilder from './config/RuntimeBuilder';
import runMain from './config/Main';

const runTrackingFramework = (win, flags) => {
	runPage(win);
	runForm(win);
	runCommand(win);
	runEventHandler(win, flags);
	runEventHandlerDecorator(win);
	runInteractionListener(window);
	runInjector(window);
	runComponent(window);
	runRuntimeBuilder(window);
	runMain(window);
};

export default runTrackingFramework;
